import type { AnyFSA } from '@makemydeal/dr-browser-utils';

// selectors
import type { StateTree } from '@makemydeal/dr-dash-types';
import type { ReduxNext, ReduxStore } from '@makemydeal/dr-shared-store';
import { PAYMENT_FAILURE, PAYMENT_RECEIVED } from '../actionTypes/deskingActionTypes';
import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import { getDealerDiscountsLoggingContext } from '../selectors/dealerDiscountsSelectors';
import {
    APPLY_DEALER_DISCOUNTS,
    APPLY_DEALER_DISCOUNTS_FAILURE,
    APPLY_DEALER_DISCOUNTS_SUCCESS
} from '../actionTypes/dealerDiscountsActionTypes';

export const middleware = (store: ReduxStore<StateTree>) => (next: ReduxNext) => (action: AnyFSA) => {
    next(action);
    const state = store.getState();

    switch (action.type) {
        case PAYMENT_RECEIVED: {
            const payload = action.payload;
            const actionForPayment = payload?.actionForPayment;

            if (actionForPayment === APPLY_DEALER_DISCOUNTS) {
                store.dispatch({ type: APPLY_DEALER_DISCOUNTS_SUCCESS });
            }
            break;
        }

        case PAYMENT_FAILURE: {
            const actionForPayment = action.meta?.actionForPayment;

            if (actionForPayment === APPLY_DEALER_DISCOUNTS) {
                const loggingContext = getDealerDiscountsLoggingContext(state);
                const meta = action.meta;
                const error = meta.error;
                const errorMessage = error?.message || 'Failed to apply discount';

                logNewRelicPageAction('MV:Dealer Discounts - Apply Failure', {
                    ...loggingContext,
                    ...meta
                });
                store.dispatch({
                    type: APPLY_DEALER_DISCOUNTS_FAILURE,
                    payload: { error: errorMessage }
                });
            }
            break;
        }
    }
};
